import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import AdminNavigation from '../Inc/AdminNavigation';
import AlumniNavigation from '../Inc/AlumniNavigation';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import warningAlert from './warning-alert.png';
import { Spin, Modal, notification, Upload, Popconfirm, message, Avatar, Empty, AutoComplete, Button, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker } from 'antd';
import { compose } from 'recompose';
import moment from 'moment';
import { history } from '../../container/History'
import './profile.css';
import AlumniInfo from './AlumniInfo';
import ContactInfo from './ContactInfo';
import AddressInfo from './AddressInfo';
import SocialInfo from './SocialInfo';
import AdditionalInfo from './AdditionalInfo';
import Skeleton from 'react-loading-skeleton';
import Compress from 'compress.js'
import NESARegistrations from "../MaintainAlumni/NESARegistrations";
import MyAwardsComponent from "../Inc/AwardSections";
import AlumniPrivacyOptions from "../Inc/AlumniPrivacyOptions";
import PrivacyModalBox from '../Inc/PrivacyModalBox';
import HobbiesAndBusinessComponent from '../Inc/HobbiesAndBusiness';
import AllNesaMembership from './AllNesaMembership';
import Item from 'antd/lib/list/Item';
import AddPerson from '../RecordRepair/AddPerson';

import GetRanksDate from "../Inc/GetRanksDate";

const compress = new Compress()
const { Option } = AutoComplete;

let Profilepic_updated = false
let personGUID = ''
let getEagleInfoArr = {}
let getSelectedEagleArr = {}
let nesaMembershipDetails = {}
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const TabPane = Tabs.TabPane;
const Panel = Collapse.Panel;
const FormItem = Form.Item;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const currentDate = new Date();
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

const URLtoBase64 = (url, callback) => {
  const xhr = new XMLHttpRequest();
  xhr.onload = () => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
};

const dummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

async function resizeImageFn(file) {

  const resizedImage = await compress.compress([file], {
    size: 1, // the max size in MB, defaults to 2MB
    quality: 1, // the quality of the image, max is 1,
    maxWidth: 320, // the max width of the output image, defaults to 1920px
    maxHeight: 320, // the max height of the output image, defaults to 1920px
    resize: true // defaults to true, set false if you do not want to resize the image width and height
  })
  const img = resizedImage[0];
  const base64str = img.data
  const imgExt = img.ext
  const resizedFiile = Compress.convertBase64ToFile(base64str, imgExt)
  console.log(resizedFiile)
  return resizedFiile;
}

function beforeUpload(file) {
  let CompressedImage = resizeImageFn(file)
  //return CompressedImage
  let isJPG;
  if (file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png') {
    isJPG = true
  }else{
    isJPG = false
    message.error('You can only upload Image file (.jpg,.jpeg,.png)!');
  }
  const isLt2M = file.size / 1024 / 1024;
  if (isLt2M > 1) {
    message.error('Image must smaller than 1MB!');
    return false
  }
  return isJPG && isLt2M;
}


function renderTitle(title) {
  return (
    <span>
      {title}
    </span>
  );
}


let picturemethod = ''
class MyProfile extends Component {

  constructor(props) {
    super(props)
    this.state = {
      modalvisible: false,
      loading: false,
      PrivacyProfileId: '',
      InfoVisible: false,
      hasCurrentNESAmembership: false,
      EagleResults: [],
      selectedEagle: [],
      Membership: undefined,
      memberSelectedKey: 0,
      showResultModal: false,
      NoResultsMatchProfile: false,
      isPrivacyVisible: false,
    }
  }

  
   proShowModal = () => {
    this.setState({
      isPrivacyVisible: true,
    });
  };

   proHandleOk = (e) => {
    console.log(e);
    this.setState({
      isPrivacyVisible: false,
    });
  };

   proHandleCancel = (e) => {
    console.log(e);
    this.setState({
      isPrivacyVisible: false,
    });
  };
  
  handleMenuClick = (e) => {
    if (e.key === "1") {
      this.props.actions.updatePrivacySettings(
        this.state.PrivacyProfileId,
        "0"
      );
    }
    if (e.key === '2') {
      this.props.actions.updatePrivacySettings(this.state.PrivacyProfileId, '100')
    }
  };

  setProgramId = () =>{
    if (this.props.nesa_reg && this.props.nesa_reg.length !== 0) {
      this.props.nesa_reg.map(eachReg => {
        if (moment(currentDate).isSameOrBefore(eachReg.expireDate) && moment(currentDate).isSameOrAfter(eachReg.effectiveDate) || eachReg.expireDate == null) {
          let selectedEagle = this.state.selectedEagle ? this.state.selectedEagle : [] ;
          selectedEagle.programId = eachReg.programId
          this.setState({
            selectedEagle
          })
        }
      })
  }
}

  componentDidMount = () => {
    if(this.props.isadmin == true ) {
      localStorage.setItem("panelView", JSON.stringify("adminTabView"))
    }
    if(this.props.isspecialist === true ) {
      localStorage.setItem("panelView", JSON.stringify("specialistTabView"))
    }
    else if(this.props.isadmin == false || this.props.isspecialist === false ) {
      localStorage.setItem("panelView", JSON.stringify("alumniTabView"))
    }
    this.props.actions.isadmin()
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    personGUID = loggedinUser.personGuid;
    let userid = loggedinUser.account.userId
    this.props.actions.getEagleInfo()
    this.props.actions.getProfileInfo(personGUID)
    let memberid = loggedinUser.membership.memberId
    this.props.actions.getAlumniEagleInfo(personGUID)
    this.props.actions.getNESARegistrations(personGUID)
    this.props.actions.getNESAmembershiplevels()
    //this.props.actions.getMyRanks(memberid)
    //this.props.actions.getAllRanks()
    this.props.actions.getAwards(personGUID, 'self')
    this.props.actions.getallscoutingassociations()
    this.props.actions.getallcouncils()
    this.props.actions.getAllAffinityGroups()
    this.props.actions.getAllLocalAwards()
  }

  checkCurrentMembership = (nesa_reg) => {
    if (nesa_reg && nesa_reg.length !== 0) {
      nesa_reg.map(Item => {
        if (moment(currentDate).isBefore(Item.expireDate)) this.setState({ hasCurrentNESAmembership: true })
      })
    }
  }
  

showResults = () => {
  this.setState({
      showResultModal: true
  })
}

closeResult = () => {
  this.setState({
      showResultModal: false
  })
}

NoResultsMatchMyProfileAlert = () => {
  this.setState({
      NoResultsMatchProfile: true,
      showResultModal: false,
  })
}
closeNorecordsMatchProfile = () => {
  this.setState({
      NoResultsMatchProfile: false
  })
  history.push('/my-profile')
}

show_NoResultsFound_Modal = () => {
  this.setState({
      NoResultsFound: true
  })
}
close_NoResultsFound_Modal = () => {
  this.setState({
      NoResultsFound: false
  })
  // history.push('/my-profile')
}

  componentWillReceiveProps = (nextprops) => {
    if(this.props.scoutings_adding != nextprops.scoutings_adding && !nextprops.scoutings_adding){
      this.setState({
        showNESARegistrationsModal: false,
        // hasCurrentNESAmembership: false
      })
      this.props.actions.getNESARegistrations(personGUID);
    }
    // if (this.props.nesa_reg != nextprops.nesa_reg) {
    //   if (nextprops.nesa_reg && nextprops.nesa_reg.length !== 0) {
    //     let ActiveMembership = [];
    //     let currentMembership =  nextprops.nesa_reg.some(Item => {
    //         if(moment(currentDate).isSameOrBefore(Item.expireDate) && moment(currentDate).isSameOrAfter(Item.effectiveDate) || Item.expireDate == null){
    //           ActiveMembership.push(Item)
    //         return true
    //        }
    //     })
    //     this.setState({ hasCurrentNESAmembership : currentMembership ? true : false, ActiveMembership})
    //   }
    //   else{
    //     this.setState({ hasCurrentNESAmembership : false})
    //   }
    // }

    if(this.props.eagleInfo != nextprops.eagleInfo){
      this.setState({
        selectedEagle : nextprops.eagleInfo
      })
    }

    if (this.props.searchedEagle !== nextprops.searchedEagle) {
      if (nextprops.searchedEagle) {
          let filterSearchedEagle = nextprops.searchedEagle.filter((each, i) => {
            return (nextprops.searchedEagle.findIndex(item => item.memberId == each.memberId) == i) && each.eagleBoardReviewDate != "" && each.eagleBoardReviewDate != null && each.eagleCertificationDate != "" && each.eagleCertificationDate != null && each.memberId != '' && each.memberId != null 
        // }
      })
          let length = filterSearchedEagle.length
          
          if (length == 1) { 
              // const current = this.state.current + 1;
              // this.props.actions.getProfileInfo(filterSearchedEagle[0].personGuid)
              // this.props.actions.getAlumniEagleInfo(filterSearchedEagle[0].personGuid)

              // let getValidEagleDetails = this.getValidEagleStateHandler(filterSearchedEagle[0].eagleState, filterSearchedEagle[0].eagleCity)

              this.props.actions.getNESARegistrations(filterSearchedEagle[0].personGuid, true);
              this.setState(
                  {
                      showNESARegistrationsModal: true,
                      InfoVisible: false,
                      // current: 2,
                      // personGUID: filterSearchedEagle[0].personGuid,
                      EagleResults: filterSearchedEagle,
                      selectedEagle: filterSearchedEagle,
                      // selectedRecord: filterSearchedEagle[0],
                      // scoutsCountry: filterSearchedEagle[0].countryId,
                      // phoneCountryId,
                      // PhoneNumber,
                      // getValidEagleState: getValidEagleDetails.getValidEagleState,
                      // getValidEagleCity: getValidEagleDetails.getValidEagleCity
                  }
              );
          }
          if (length > 1) {
              this.showResults()
              // let getValidEagleDetails = this.getValidEagleStateHandler(filterSearchedEagle[0].eagleState, filterSearchedEagle[0].eagleCity)
              this.setState({
              //     // showResultModal: true,
              //     phoneCountryId,
              //     PhoneNumber,
              //     selectedRecord: filterSearchedEagle[0],
              //     scoutsCountry: filterSearchedEagle[0].countryId,
                  EagleResults: filterSearchedEagle,
                  selectedEagle: filterSearchedEagle[0],
                  showResultModal: true,
                  InfoVisible: false,
                  // hasCurrentNESAmembership:false
              //     personGUID: filterSearchedEagle[0].personGuid,
              //     getValidEagleState: getValidEagleDetails.getValidEagleState,
              //     getValidEagleCity: getValidEagleDetails.getValidEagleCity
              })
          }
        }
      }
    }
  
  

  showModal = () => {
    this.setState({
      modalvisible: true,
    });
  }

  modalOk = (e) => {
    console.log(e);
    this.setState({
      modalvisible: false,
    });
  }

  modalCancel = (e) => {
    console.log(e);
    this.setState({
      modalvisible: false,
    });
  }

  address = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={200} />
    } else {
      let personaddress = this.props.profileinfo.addresses.filter((data) => data.isPrimary == 'True')[0]
      if (personaddress) {
        return (<span> <i class='fa fa-map-marker'></i> {personaddress.city + " " + personaddress.state + " " + personaddress.zipCode} </span>)
      }
      return <Skeleton width={200} />
    }
  }

  email = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={200} />
    } else {
      let personemail = this.props.profileinfo.emails.length > 0 ? this.props.profileinfo.emails.filter(data => (typeof(data.isPrimary) === "string" && data.isPrimary.toLowerCase() === "true" || typeof(data.isPrimary) === "boolean" && data.isPrimary))[0] : ''
      if (personemail) {
        return (<span> <i class='fa fa-envelope'></i> {personemail.email} </span>)
      }
      return (<span> <i class='fa fa-envelope'></i> N/A </span>)
    }
  }

  phone = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={200} />
    } else {
      let personphone = this.props.profileinfo.phones.length > 0 ? this.props.profileinfo.phones.filter(data => ((typeof(data.isPrimary) === "string" && data.isPrimary.toLowerCase() === "true") || typeof(data.isPrimary) === "boolean" && data.isPrimary))[0] : '';
      let phoneNumber;
      if (personphone) {
        const countryCode = personphone.countryCode ? personphone.countryCode.replace(/^0+/, '') : "--";
        if(personphone.country && personphone.country === "USA") {
          const areaCode = personphone.areaCode ? personphone.areaCode : '';
          const prefix = personphone.prefix ? personphone.prefix : '';
          const lineNumber = personphone.lineNumber ? personphone.lineNumber : '';
          phoneNumber = `${countryCode} ${areaCode} ${prefix} ${lineNumber}`
        } else {
          const truncatedphoneNumber = personphone.fullPhoneNumber ? personphone.fullPhoneNumber.substr(personphone.fullPhoneNumber.indexOf(' ')+1) : `${personphone.areaCode} ${personphone.prefix} ${personphone.lineNumber}`;
          const trimmedNumber = truncatedphoneNumber.trim().replace(/^0+/, '');
          phoneNumber = `${countryCode} ${trimmedNumber}`
        }

        return (<span> <i class='fa fa-phone'></i> {phoneNumber ? ` +${phoneNumber}` : ""} </span>)
      }
      return (<span> <i class='fa fa-phone'></i> N/A </span>)
    }
  } 

  name = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={200} />
    }
    else if(this.props.profileinfo){
      const { profile } = this.props.profileinfo || {};
      const { firstName, middleName, lastName, nameSuffix, fullName } = profile || {};

      const formattedName = [firstName, middleName, lastName, nameSuffix].filter(Boolean).join(' '); //filter(Boolean) method to remove any falsy values (empty strings or undefined properties).
      return formattedName || fullName;

      // return this.props.profileinfo.profile.nickName != "" ? this.props.profileinfo.profile.nickName + " " + this.props.profileinfo.profile.lastName : this.props.profileinfo.profile.fullName
    }else{
      return <Skeleton width={200} />
    }
  }
  checkIsDeceased = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={100} />
    }   
    else{
      const { profile } = this.props.profileinfo || {};
      const { isDeceased } = profile || this.props.profileinfo;

      return isDeceased ? " - Deceased" : '';
    }
  }


  renderRanks = () => {
    if (this.props.ranks_loading)
      return <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Ranks..." />
    if (this.props.ranks && this.props.allranks) {
      let ranks = this.props.ranks
      let allranks = this.props.allranks.ranks
      if (ranks.length == 0)
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      else {
        return ranks.map((k, index) => {
          return allranks.map((j, index) => {
            const earnedDate = GetRanksDate(k, this.props.eagleInfo);
            if (k.rankId == j.id) {
              return (<Row type='flex' justify='flex-start' align='middle'>
                <Col span={6} className='text-center'>
                  <img src={j.imageUrl100} className='rank-img' />
                </Col>
                <Col span={18}>
                  <Row type='flex' justify='flex-start' align='middle'>
                    <Col span={24}>
                      <span className='rank-name'>{k.rankName}</span>
                    </Col>
                    <Col span={24}>
                      <span className='rank-date'>{earnedDate ? earnedDate : '-'}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>)
            }
          })
        })
      }
    }
  }

  handleChange = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      getBase64(info.file.originFileObj, imageUrl => {
        this.props.actions.updateProfilePicture(personGUID, imageUrl, picturemethod, 'Updated')
        this.setState({
          imageUrl,
          loading: false,
        })
      }
      );
    }
  }

  RemovePicture = (self) => {
    URLtoBase64('../profileimage.png', (Base64) => {
      this.props.actions.updateProfilePicture(personGUID, Base64, 'PUT', 'Removed')
      this.setState({
        imageUrl: '../profileimage.png',
        loading: false,
      })
    });
  }

  CheckforSocialContacts = () => {
    if (this.props.profileinfo) {
      let profile = this.props.profileinfo
      let webcontacts = profile.webContacts
      if (webcontacts.length != 0) {
        notification['warning']({
          description:
            'Enter your social media links to connect with another alumni.',
        });
      }
    }
  }

  renderProfileImg = () => {
    if (!this.props.profileinfo) {
      return <Spin indicator={antIcon} className='profile-img flex-center' />
    }
    else if (this.props.pic_updating) {
      Profilepic_updated = false
      return <Spin indicator={antIcon} className='profile-img flex-center' />
    }
    else if (this.props.pic_updated && !Profilepic_updated) {
      Profilepic_updated = true
      const imageUrl = this.state.imageUrl;
      picturemethod = 'PUT'
      return <img src={imageUrl} className='profile-img' />
    }
    else if (!this.props.pic_updated || Profilepic_updated == true) {
      let profile = this.props.profileinfo
      let imgurl = profile && profile.profile &&  profile.profile.pictureUrl ? profile.profile.pictureUrl : profile && profile.pictureUrl ? profile.pictureUrl : '';
      if (imgurl == "" || imgurl == null) {
        imgurl = "../profileimage.png"
        if (picturemethod == '') picturemethod = 'POST'
      } else {
        if (picturemethod == '') picturemethod = 'PUT'
      }
      return <img src={imgurl} className='profile-img' />
    }
    else {
      if (picturemethod == 'PUT') {
        return <img src={this.state.imageUrl} className='profile-img' />
      }
      let imgurl = "../profileimage.png"
      return <img src={imgurl} className='profile-img' />
    }
  }

  privacysettings = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={200} />
    } else {
      let privacysettings = this.props.profileinfo.extendedProfile.filter((data) => data.attributeId == "17")[0]
      if (privacysettings) {
        if (this.state.PrivacyProfileId == '') {
          this.setState({
            'PrivacyProfileId': privacysettings.extendedProfileId
          })
        }
      }


      return (
        <div>
          <div>
   
            <p className="profile-para">
              The Spark Directory security module is designed to display only
              the information you want shared with other directory users.
              Select the
              <span className="sdpp" onClick={this.proShowModal}>
                Spark Directory Privacy Policy
              </span>
              to view the Spark privacy policy.  
              To review or update your privacy settings please review your 'My Privacy Settings' listed below.
            </p>
          </div>
          <PrivacyModalBox
                    send={this.state.isPrivacyVisible}
                    okay={this.proHandleOk}
                    cancel={this.proHandleCancel}
                  />
        
        </div>
        // <Dropdown
        //   placement="bottomRight"
        //   overlay={
        //     <Menu onClick={this.handleMenuClick}>
        //       <Menu.Item key="1">
        //         <span>
        //           <i className="fa fa-eye" aria-hidden="true"></i> I want other
        //           alumni to find me
        //         </span>
        //       </Menu.Item>
        //       <Menu.Item key="2">
        //         <span>
        //
        //           <i className="fa fa-eye-slash" aria-hidden="true"></i> I don't
        //           want other alumni to find me
        //         </span>
        //       </Menu.Item>
        //     </Menu>
        //   }
        // >
        //   <a className="ant-dropdown-link" href="#">
        //     <i
        //       className={
        //         privacysettings
        //           ? privacysettings.attributeVal == "0"
        //             ? "fa fa-eye"
        //             : "fa fa-eye-slash"
        //           : "fa fa-eye"
        //       }
        //     ></i>
        //     <span className="privacy-settings"> Privacy Settings: </span>
        //     {privacysettings
        //       ? privacysettings.attributeVal == "0"
        //         ? "VISIBLE"
        //         : "HIDDEN"
        //       : "HIDDEN"}
        //     <Icon type="down" />
        //   </a>
        // </Dropdown>
      );
    }
  }

  rendereagleflag = () => {
    if (this.props.eagleInfo) {
      if (Object.keys(this.props.eagleInfo).length != 0) {
        if (this.props.eagleInfo.eagleBoardReviewDate != "") {
          return <img className="eagle-logo" src='./eagle-scout.png' />
        }
      }
    }
  }

  renderAwards = () => {
    if (this.props.awardsloading) {
      return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Awards..." />
    }
    if (this.props.awards) {
      let award = this.props.awards.awards
      var distintic_awards = award.reduceRight(function (r, a) {
        r.some(function (b) { return a.name === b.name; }) || r.push(a);
        return r;
      }, []);
      if (distintic_awards.length == 0) {
        return <Row className='width-100' type='flex' align='middle' justify='center'>
          <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <img className='memb-img' src="../noawards.png" />
            </Col>
            <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
              <Row type='flex' align='bottom' justify='center'>
                <span className='memb-exp'>No Awards Found!</span>
              </Row>
            </Col>
          </Col>
        </Row>
      } else {
        return distintic_awards.map((k, index) => {
          let imgurl = (k.imageFilePath == "" || k.imageFilePath == null) ? "../noawards.png" : k.imageFilePath
          return (
            <Row type='flex' className='awardcontainer' justify='flex-start' align='middle'>
              <Col span={6} className='text-center'>
                <img src={imgurl} className='award-img' />
              </Col>
              <Col span={18}>
                <Row type='flex' justify='flex-start' align='middle'>
                  <Col span={24}>
                    <span className='award-name'>{k.name}</span>
                  </Col>
                  {/* <Col span={24}>
                  <span className='award-date'>{k.dateEarned}</span>
                </Col> */}
                </Row>
              </Col>
            </Row>)
        })
      }
    }
  }

  renderRenewMembershipButton = () => {
    let expireDate = '';

    if(this.props.nesa_reg && this.props.nesa_reg.length !== 0){
        this.props.nesa_reg.map((k, index) => {
          if(k.isActive === true){
            expireDate = k.expireDate
          }
        })
    }
    
    const currentDate = new Date();
    const eagleExpireDate = new Date(expireDate);
    const expireLimit = 6;

    const monthDifference = Math.max(
      (eagleExpireDate.getFullYear() - currentDate.getFullYear()) * 12 + eagleExpireDate.getMonth() - currentDate.getMonth(), 0
    )

    if(monthDifference <= expireLimit){
      return (
        <div className="RenewMembershipSection">
          <Button key="back" className="RenewMembershipHandler" onClick={this.RenewMembershipHandler}>
              Renew Membership
          </Button>
        </div>
      )
    }else{
      return;
    }

  }

  RenewMembershipHandler = () => {
    history.push('/purchase-membership')
  }

  addscoutings = (value) => {
    if (value == "National Eagle Scout Association") {
      this.setState({
        InfoVisible: true
      })
    } 
    else {
      this.props.actions.addScoutings(value)
    }
  }

  gotoPurchaseMembership = () => {
    this.setState({
      InfoVisible: false
    })
    history.push('/purchase-membership')
  }

   showEagleScoutInformation = () => {
    this.setState({
      EagleScoutInfoVisible: true,
      InfoVisible: false
    })
  }

  renderEagleCouncilNumber = () => {
    if ( this.props.eagleInfo && this.props.eagleInfo.eagleCouncilName != '' ) {
      let councilName = this.props.eagleInfo && this.props.eagleInfo.eagleCouncilName 
    ? this.props.eagleInfo.eagleCouncilName : '';

      let extract = councilName.match(/\d+/g);
      const councilNumber = extract[0] ? extract[0] : '';

    return councilNumber;
    }
    
  }

  renderEagleMembershipInfo = () => {
      let nesareg = this.props.nesa_reg ? this.props.nesa_reg : []
      let nesalevels = this.props.nesa_levels ? this.props.nesa_levels : [];

      let membershipType = '';
      let membershipId = '';
      let expiryDate = '';

      if (nesareg.length != 0 && nesalevels.length !=0 && nesareg != "error"){
        nesareg.map((k, index) => {
          if(k.isActive === true){
            membershipId = k.programId
            expiryDate = k.expireDate

            nesalevels.map((j, index) => {
              if(parseInt(j.id) == membershipId){
                membershipType = j.name;
              }
            })
          }
        })
      }

      return (
        <div className="EagleMembershipInfo">
          <span className="MembershipTypeInfo">Membership Type: </span>
          <span className="MembershipTypeInfoValue">{membershipType}</span>
          
          <span className="MembershipExpirationDate">Expiration Date: </span>
              <span className="MembershipExpirationDateValue">{
                expiryDate ? moment(expiryDate).format('MM/DD/YYYY') : '---'}
              </span>
        </div>
      )
  }

  closeEagleScoutInfoModal = () => {
    this.setState({
      EagleScoutInfoVisible: false,
    })
    history.push('/')
  }

  showEagleIncompleteInfoModal = () => {
    this.setState({
      EagleincompleteInfoVisible: true,
      InfoVisible: false
    })
  }

  closeEagleIncompleteInfoModal = () => {
    this.setState({
      EagleincompleteInfoVisible: false
    })
    history.push('/');
  }

  renderMisssingEagleInfo = () => {
    let requiredEagleInfo = {
      'Member Id' : this.state.selectedEagle && this.state.selectedEagle.memberId ? this.state.selectedEagle.memberId : '',
      'Board Review Date' : this.state.selectedEagle && this.state.selectedEagle.eagleBoardReviewDate ? this.state.selectedEagle.eagleBoardReviewDate : '',
      'Date Of Birth' : this.state.selectedEagle && this.state.selectedEagle.dateOfBirth ? this.state.selectedEagle.dateOfBirth : '',
      'Certification Date' : this.state.selectedEagle && this.state.selectedEagle.eagleCertificationDate ? this.state.selectedEagle.eagleCertificationDate : '',
    };

    let missingEagleInfoProperty = []
    for (const property in requiredEagleInfo) {
      if(requiredEagleInfo[property] === ''){
        missingEagleInfoProperty.push(property)
      }
    }

    const missingInfo = missingEagleInfoProperty.join(', ');

    return missingInfo;
  }

  Closemodal = () => {
    this.setState({
      InfoVisible: false
    })
  }

  addCouncils = (value) => {
    this.props.actions.addCouncils(value)
  }

  addAffinities = (value) => {
    this.props.actions.addAffinities(value);
  }

  addLocalAwards = (value) => {
    this.props.actions.addLocalAwards(value);
  }

  // rendermyeaglecouncil = () => {
  //   if (this.props.eagleInfo) {
  //     if (Object.keys(this.props.eagleInfo).length !== 0) {
  //       if (this.props.eagleInfo.eagleCouncilName != '') {
  //         let eagleCouncil = ''
  //         if (this.props.eagleInfo.eagleCouncilName) {
  //           eagleCouncil = this.props.eagleInfo.eagleCouncilName.replace(/ *\([^)]*\) */g, "")
  //         }
  //         return (
  //           <div className='scoutingaffiliations'>
  //             <Row type='flex' className='awardsection' justify='flex-start' align='middle'>
  //               <Col span={20}>
  //                 <Row type='flex' justify='flex-start' align='middle'>
  //                   <Col span={24}>
  //                     <span className='m-l-20 award-name'>{eagleCouncil}</span>
  //                   </Col>
  //                 </Row>
  //               </Col>
  //               <Col span={2}>
  //                 <img className="eagle-logo" src='./eagle-scout.png' />
  //               </Col>
  //             </Row>
  //           </div>)
  //       }
  //     }
  //   }
  // }

  // rendermycouncils = () => {
  //   if (this.props.councils_adding) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Adding Council Affliations..." />
  //   }
  //   else if (this.props.councils_deleting) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Deleting Council Affliations..." />
  //   }
  //   else if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Council Affliations..." />
  //   }
  //   else if (this.props.profileinfo && this.props.councils && this.props.eagleInfo) {
  //     let councilresources = this.props.profileinfo.extendedProfile
  //     return councilresources.map((k, index) => {
  //       if (k.attributeId == '21') {
  //         if (this.props.eagleInfo.eagleCouncilName) {
  //           if (this.props.eagleInfo.eagleCouncilName.replace(/ *\([^)]*\) */g, "") == k.attributeVal) {
  //             return false
  //           }
  //         }
  //         return (
  //           <div className='scoutingaffiliations'>
  //             <Row type='flex' className='awardsection' justify='flex-start' align='middle'>
  //               <Col span={22}>
  //                 <Row type='flex' justify='flex-start' align='middle'>
  //                   <Col span={24}>
  //                     <span className='m-l-20 award-name'>{k.attributeVal}</span>
  //                   </Col>
  //                 </Row>
  //               </Col>
  //               <Col span={2}>
  //                 <Row type='flex' justify='flex-start' align='middle'>
  //                   <Col span={24}>
  //                     <Popconfirm
  //                       title="Are you sure you want to delete this?"
  //                       onConfirm={() => this.props.actions.deleteScouting("council", k.extendedProfileId)}
  //                       okText="Yes"
  //                       cancelText="No"
  //                     >
  //                       <i  className="fa fa-times-circle red pointer" aria-hidden="true"></i>
  //                     </Popconfirm>
  //                   </Col>
  //                 </Row>
  //               </Col>
  //             </Row>
  //           </div>)
  //       }
  //     })
  //   }
  // }

  // renderMyAffinityGroups = () => {
  //   if (this.props.affinities_loading) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Affinity Groups..." />
  //   }
  //   if (this.props.affinities_loading) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Deleting Affinity Group..." />
  //   }
  //   if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Affinity Groups..." />
  //   }

  //   if(this.props.profileinfo && this.props.affinities) {
  //     let affinityResources = this.props.profileinfo.extendedProfile;

  //   this.props.affinities.sort((a,b) => {
  //     return a.name.localeCompare(b.name);
  //   })

  //   return affinityResources.map((k, index) => {
  //     if (k.attributeId == '22') {
  //       return this.props.affinities.map((j, index) => {
  //         if (k.attributeVal == j.name) {
  //           let imgurl = (j.logo == "" || j.logo == null) ? "../nonationalassociation.png" : j.logo
  //           return (
  //             <div className='affinitiessection'>
  //               <Row type='flex' justify='flex-start' align='middle'>
  //                 <Col span={9} className='text-center'>
  //                   <img src={imgurl} className='award-img' />
  //                 </Col>
  //                 <Col span={13}>
  //                   <Row type='flex' justify='flex-start' align='middle'>
  //                     <Col span={24}>
  //                       <span className='award-name'>{j.name}</span>
  //                     </Col>
  //                     {/* <Col span={24}>
  //               <span className='award-date'>{k.dateEarned}</span>
  //             </Col> */}
  //                   </Row>
  //                 </Col>
  //                 <Col span={2}>
  //                   <Row type='flex' justify='flex-start' align='middle'>
  //                     <Col span={24}>
  //                       <Popconfirm
  //                         title="Are you sure you want to delete this?"
  //                         onConfirm={() => this.props.actions.deleteAffinity(k.extendedProfileId)}
  //                         okText="Yes"
  //                         cancelText="No"
  //                       >
  //                         <i  className="fa fa-times-circle red pointer" aria-hidden="true"></i>
  //                       </Popconfirm>
  //                     </Col>
  //                   </Row>
  //                 </Col>
  //               </Row>
  //             </div>)
  //         }
  //       })
  //     }
  //   })

  //   }
  // }

  // rendermyscoutings = () => {
  //   if (this.props.scoutings_adding) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Adding Scouting Affliations..." />
  //   }
  //   if (this.props.scoutings_deleting) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Deleting Scouting Affliations..." />
  //   }
  //   if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Scouting Affliations..." />
  //   }
  //   if (this.props.profileinfo && this.props.scoutings) {
  //     let scoutingresources = this.props.profileinfo.extendedProfile
  //     if(this.state.ActiveMembership) getEagleInfoArr =  this.state.ActiveMembership[0] ? this.state.ActiveMembership[0] : this.state.ActiveMembership
  //     console.log('getEagleInfoArr', getEagleInfoArr);
      
  //     if(this.state.selectedEagle) getSelectedEagleArr = this.state.selectedEagle.length !=0 ? this.state.selectedEagle : []
  //     console.log('getSelectedEagleArr', getSelectedEagleArr);

  //     let nesaMembershipDetails = {...getEagleInfoArr, ...getSelectedEagleArr}
  //     console.log('nesaMembershipDetails', nesaMembershipDetails);

  //     //asc order
  //     this.props.scoutings.sort((a, b) => {
  //       return a.name.localeCompare(b.name);
  //     });
  //     return scoutingresources.map((k, index) => {
  //       if (k.attributeId == '20') {
  //         return this.props.scoutings.map((j, index) => {
  //           if (k.attributeVal == j.name) {
  //             let imgurl = (j.logo == "" || j.logo == null) ? "../nonationalassociation.png" : j.logo
  //             return (
  //               <div className='scoutingaffiliations'>
  //                 {/* <Row className='affinityIcons' type='flex' align='bottom' justify='end'>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Love">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/love.png")} onMouseOver={e => (e.currentTarget.src = "/h-love.png")} className='pointer' src='/love.png' />
  //                 </Tooltip>
  //               </Col>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Volunteer">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/volunteer.png")} onMouseOver={e => (e.currentTarget.src = "/h-volunteer.png")} className='pointer' src='/volunteer.png' />
  //                 </Tooltip>
  //               </Col>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Camp">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/camp.png")} onMouseOver={e => (e.currentTarget.src = "/h-camp.png")} className='pointer' src='/camp.png' />
  //                 </Tooltip>
  //               </Col>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Donate">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/dollar.png")} onMouseOver={e => (e.currentTarget.src = "/h-dollar.png")} className='pointer' src='/dollar.png' />
  //                 </Tooltip>
  //               </Col>
  //             </Row>
  //             */}
  //                 <Row type='flex' className='awardsection' justify='flex-start' align='middle'>
  //                   <Col span={6} className='text-center'>
  //                     <img src={imgurl} className='award-img' />
  //                   </Col>
  //                   <Col span={16}>
  //                     <Row type='flex' justify='flex-start' align='middle'>
  //                       {j.name === 'National Eagle Scout Association' && this.state.hasCurrentNESAmembership ? 
  //                           <Col span={24} onClick={this.showEagleScoutInformation}>
  //                             <Row type='flex' justify='flex-start' align='middle'>
  //                               <Col span={24}>
  //                                 <span className='award-name'>{Number(nesaMembershipDetails.programId) == 30 ? 'NESA 5Year' : 'NESA Lifetime'}</span>
  //                               </Col>
  //                               <Col span={24}>
  //                                 <span className='m-l-0 award-date'>expires {nesaMembershipDetails.expireDate ? moment(nesaMembershipDetails.expireDate).format('MM/DD/YYYY') : "-"}</span>
  //                               </Col>
  //                             </Row>
  //                           </Col>
  //                         :
  //                         <Col span={24}>
  //                           <span className='award-name'>{j.name}</span>
  //                         </Col>
  //                       }
  //                       {/* <Col span={24}>
  //                 <span className='award-date'>{k.dateEarned}</span>
  //               </Col> */}
  //                     </Row>
  //                   </Col>
  //                   <Col span={2}>
  //                     <Row type='flex' justify='flex-start' align='middle'>
  //                       <Col span={24}>
  //                         <Popconfirm
  //                           title="Are you sure you want to delete this?"
  //                           onConfirm={() => this.props.actions.deleteScouting("scoutings", k.extendedProfileId)}
  //                           okText="Yes"
  //                           cancelText="No"
  //                         >
  //                           <i  className="fa fa-times-circle red pointer" aria-hidden="true"></i>
  //                         </Popconfirm>
  //                       </Col>
  //                     </Row>
  //                   </Col>
  //                 </Row>
  //               </div>)
  //           }
  //         })
  //       }
  //     })
  //   }
  // }

  renderViewNesaStatusButton = () => {
    if (this.props.nesa_reg && this.props.nesa_levels) {
      let nesareg = this.props.nesa_reg
      let nesalevels = this.props.nesa_levels
      let Membership_ID = ''
      let Membership_Name = ''
      let expireDate = ''
      let ActiveMembership = false;
      if (nesareg.length != 0 && nesareg != "error") {
        nesareg.map((k, index) => {
          if (k.isActive === true) {
            ActiveMembership = true
            Membership_ID = k.programId
            expireDate = k.expireDate
            nesalevels.map((j, index) => {
              if (parseInt(j.id) == Membership_ID) {
                Membership_Name = j.name
              }
            })
          }
        })
        if (ActiveMembership) {
          return (
            <div>
              <Button type="primary" className="ViewCurrentNESAStatus" onClick={this.props.eagleInfo && this.props.eagleInfo.memberId 
                && this.props.eagleInfo.eagleBoardReviewDate  ? this.showEagleScoutInformation : this.showEagleIncompleteInfoModal}>
                  View Current Status
              </Button>
            </div>
          )
        }
      }
    }

  }

  // renderscouting = () => {
  //   if (this.props.scoutings && this.props.profileinfo && this.props.nesa_reg) {
  //     let scoutingLookup = this.props.scoutings
  //     let exsitingScouting = this.props.profileinfo.extendedProfile

  //     exsitingScouting.map((k, kindex) => {
  //       if (k.attributeId == '20') {
  //         scoutingLookup = scoutingLookup.filter(function (obj) {
  //           return obj.name != k.attributeVal;
  //         });
  //       }
  //     })

  //     //Remove Order of the Arrow
  //     scoutingLookup = scoutingLookup.filter(lookup => lookup.id !== 1)

  //     // //Remove NESA
  //     // let nesareg = this.props.nesa_reg
  //     // if (nesareg.length != 0 && nesareg != "error") {
  //     //   nesareg.map((k, index) => {
  //     //     if (k.isActive === true) {
  //     //       scoutingLookup = scoutingLookup.filter(membership => membership.name !== "National Eagle Scout Association")
  //     //     }
  //     //   })
  //     // }

  //     // Removing Duplicate Affiliations
  //     let uniqueAffiliations = [];
  //     let uniqueAffiliationName = {};
  //     let affiliationTitle;

  //     for (let i in scoutingLookup) {
  //       affiliationTitle = scoutingLookup[i]['name'];
  //       uniqueAffiliationName[affiliationTitle] = scoutingLookup[i];
  //     }

  //     for (let i in uniqueAffiliationName) {
  //       uniqueAffiliations.push(uniqueAffiliationName[i]);
  //     }
  //     console.log(uniqueAffiliations);

  //     if (uniqueAffiliations.length == 0)
  //       return false

  //     return <Row style={{ width: "100%" }}>
  //       <Col span={24}>
  //         <span className='small-txt'> Please select your Scouting Affiliation: </span>
  //       </Col>
  //       <Col span={24}>
  //         <Select
  //           className='scoutingsselect'
  //           showSearch
  //           placeholder="Please select Affilitaions to add"
  //           optionLabelProp="label"
  //           style={{ width: "100%" }}
  //           onChange={this.addscoutings}
  //           value={null}
  //         >
  //           {uniqueAffiliations.map((scoutings) => (
  //             <Option key={scoutings.id} label={scoutings.name} value={scoutings.name}>
  //               <div>
  //                 <Avatar
  //                   src={scoutings.logo}
  //                   icon='shop'
  //                   size='small'
  //                 />
  //                 <span className='m-l-10'>  {scoutings.name}</span>
  //               </div>
  //             </Option>
  //           ))}
  //         </Select>
  //       </Col>
  //     </Row>
  //   }
  // }

  // renderAffinityGroups = () => {
  //   if(this.props.affinities && this.props.profileinfo){
  //     let affinityLookup = this.props.affinities;
  //     let existingAffinities = this.props.profileinfo.extendedProfile;

  //     existingAffinities.map((k, kindex) => {
  //       if (k.attributeId == '22') {
  //         affinityLookup = affinityLookup.filter(function (obj) {
  //           return obj.name != k.attributeVal;
  //         });
  //       }
  //     })


  //     //Removing duplicate affinities
  //     let uniqueAffinities = [];
  //     let uniqueAffinityName = {};
  //     let affinityTitle;

  //     for (let i in affinityLookup) {
  //       affinityTitle = affinityLookup[i]['name'];
  //       uniqueAffinityName[affinityTitle] = affinityLookup[i];
  //     }

  //     for (let i in uniqueAffinityName) {
  //       uniqueAffinities.push(uniqueAffinityName[i]);
  //     }

  //     if (uniqueAffinities.length == 0)
  //       return false

  //     return <Row style={{ width: "100%" }}>
  //       <Col span={24}>
  //         <span className='small-txt'> Please select your Affinity Group Affiliation: </span>
  //       </Col>
  //       <Col span={24}>
  //         <Select
  //           className='affinitiesselect'
  //           showSearch
  //           placeholder="Please select Affilitaions to add"
  //           optionLabelProp="label"
  //           onChange={this.addAffinities}
  //           style={{ width: "100%" }}
  //           value={null}
  //         >
  //           {uniqueAffinities.map((affinities) => (
  //             <Option key={affinities.id} label={affinities.name} value={affinities.name}>
  //               <div>
  //                 <Avatar
  //                   src={affinities.logo}
  //                   icon='shop'
  //                   size='small'
  //                 />
  //                 <span className='m-l-10'>  {affinities.name}</span>
  //               </div>
  //             </Option>
  //           ))}
  //         </Select>
  //       </Col>
  //     </Row>
  //   }
  // }

  // renderLocalAwardsSection = () => {
  //   if(this.props.localAwards && this.props.profileinfo){
  //     let localAwardsLookup = this.props.localAwards;
  //     let existingLocalAwards = this.props.profileinfo.extendedProfile;

  //     existingLocalAwards.map((k, kindex) => {
  //       if (k.attributeId == '24') {
  //         localAwardsLookup = localAwardsLookup.filter(function (obj) {
  //           return obj.name != k.attributeVal;
  //         });
  //       }
  //     })

  //     //Removing duplicate affinities
  //     let uniqueLocalAwards = [];
  //     let uniqueAwardname = {};
  //     let awardTitle;

  //     for (let i in localAwardsLookup) {
  //       awardTitle = localAwardsLookup[i]['name'];
  //       uniqueAwardname[awardTitle] = localAwardsLookup[i];
  //     }

  //     for (let i in uniqueAwardname) {
  //       uniqueLocalAwards.push(uniqueAwardname[i]);
  //     }

  //     if (uniqueLocalAwards.length == 0)
  //       return false
      
  //     return <Row style={{ width: "100%" }}>
  //     <Col span={24}>
  //       <span className='small-txt'> Please add your local awards: </span>
  //     </Col>
  //     <Col span={24}>
  //       <Select
  //         className='awardsselect'
  //         showSearch
  //         placeholder="Please select awards to add"
  //         optionLabelProp="label"
  //         onChange={this.addLocalAwards}
  //         style={{ width: "100%" }}
  //         value={null}
  //       >
  //         {uniqueLocalAwards.map((awards) => (
  //           <Option key={awards.id} label={awards.name} value={awards.name}>
  //             <div>
  //               <span className='m-l-10'>{awards.name}</span>
  //             </div>
  //           </Option>
  //         ))}
  //       </Select>
  //     </Col>
  //   </Row>

  //   }
  // }

  // renderMyLocalAwardsSection = () => {
  //   if (this.props.localAwards_Loading) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Local Awards..." />
  //   }
  //   if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Local Awards..." />
  //   }

  //   if(this.props.profileinfo && this.props.localAwards) {
  //      let awardResources = this.props.profileinfo.extendedProfile;

  //      this.props.localAwards.sort((a,b) => {
  //       return a.name.localeCompare(b.name);
  //     })

  //     return awardResources.map((k, index) => {
  //       if (k.attributeId == '24') {
  //         return this.props.localAwards.map((j, index) => {
  //           if (k.attributeVal == j.name) {
  //             return (
  //               <div className='affinitiessection'>
  //                 <Row type='flex' justify='flex-start' align='middle'>
  //                   <Col span={20}>
  //                     <Row type='flex' justify='flex-start' align='middle'>
  //                       <Col span={24}>
  //                         <span className='m-l-20 award-name'>{j.name}</span>
  //                       </Col>
  //                     </Row>
  //                   </Col>
  //                   <Col span={2}>
  //                     <Row type='flex' justify='flex-start' align='middle'>
  //                       <Col span={24}>
  //                         <Popconfirm
  //                           title="Are you sure you want to delete this?"
  //                           onConfirm={() => this.props.actions.deleteLocalAward(k.extendedProfileId)}
  //                           okText="Yes"
  //                           cancelText="No"
  //                         >
  //                           <i  className="fa fa-times-circle red pointer" aria-hidden="true"></i>
  //                         </Popconfirm>
  //                       </Col>
  //                     </Row>
  //                   </Col>
  //                 </Row>
  //               </div>)
  //           }
  //         })
  //       }
  //     })
  //   }
  // }


  // rendercouncils = () => {
  //   if (this.props.councils && this.props.profileinfo) {
  //     let councilLookup = this.props.councils
  //     let existingCouncils = this.props.profileinfo.extendedProfile
  //     //asc order
  //     this.props.councils.sort((a, b) => {
  //       return a.councilLong.localeCompare(b.councilLong);
  //     });
  //     let isadded = existingCouncils.filter(function (obj) {
  //       return obj.attributeId == '21';
  //     });
  //     if (isadded.length == 5) {
  //       return false
  //     }
  //     existingCouncils.map((k, kindex) => {
  //       if (k.attributeId == '21') {
  //         councilLookup = councilLookup.filter(function (obj) {
  //           return obj.councilLong != k.attributeVal;
  //         });
  //       }
  //     })

  //     return <Row style={{ width: "100%" }}>
  //       <Col span={24} >
  //         <span className='small-txt'> Please select your Council Affiliation: </span>
  //       </Col>
  //       <Col span={24}>
  //         <Select
  //           className='scoutingsselect'
  //           showSearch
  //           placeholder="Please select Affilitaions to add"
  //           optionLabelProp="label"
  //           style={{ width: "100%" }}
  //           onChange={this.addCouncils}
  //           value={null}
  //         >
  //           {councilLookup.map((council) => (
  //             <Option key={council.councilNumber} label={council.councilLong} value={council.councilLong}>
  //               <div>
  //                 {/* <Avatar
  //                   src={scoutings.logo}
  //                   icon='shop'
  //                   size='small'
  //                 /> */}
  //                 <span >{council.councilLong}</span>
  //               </div>
  //             </Option>
  //           ))}
  //         </Select>
  //       </Col>
  //     </Row>
  //   }
  // }

  renderWebContacts = () => {
    if (this.props.profileinfo) {
      let profile = this.props.profileinfo
      let webcontacts = profile.webContacts
      if (webcontacts.length != 0) {
        return webcontacts.map((k, index) => {
          if (k.typeId == "14") {
            return <a href={"https://" + k.type + ".com/" + k.address} target="_blank"><svg className="margin-right-10 fa-2x white pointer x-icon" width="1em" height="1em" viewBox="0 0 1200 1227" fill="currentColor" aria-hidden="true"><path d="M714.163 519.284L1160.89 0H1055.36L667.137 451.887L357.328 0H0L468.492 682.21L0 1226.37H105.527L515.256 750.965L841.672 1226.37H1199L714.137 519.284H714.163Z" /></svg></a>
          }
          if (k.typeId == "15") {
            return <a href={"https://" + k.type + ".com/" + k.address} target="_blank"><i className="fa fa-facebook-square margin-right-10 fa-2x white pointer" aria-hidden="true"></i></a>
          }
          if (k.typeId == "17") {
            return <a href={"https://" + k.type + ".com/in/" + k.address} target="_blank"><i className="fa fa-linkedin-square margin-right-10 fa-2x white pointer" aria-hidden="true"></i></a>
          }
          if (k.typeId == "19") {
            return <a href={"https://" + k.type + ".com/" + k.address} target="_blank"><i className="fa fa-instagram margin-right-10 fa-2x white pointer" aria-hidden="true"></i></a>
          }
        })
      }
    }
  }

  getNESAreg = () => {
    if (this.props.nesa_reg && this.props.nesa_levels) {
      let nesareg = this.props.nesa_reg
      let nesalevels = this.props.nesa_levels
      let Membership_ID = ''
      let Membership_Name = ''
      let expireDate = ''
      let ActiveMembership = false
      if (nesareg.length != 0 && nesareg != "error") {
        nesareg.map((k, index) => {
          if (k.isActive === true) {
            ActiveMembership = true
            Membership_ID = k.programId
            expireDate = k.expireDate
            nesalevels.map((j, index) => {
              if (parseInt(j.id) == Membership_ID) {
                Membership_Name = j.name
              }
            })
          }
        })
        if (ActiveMembership) {
          return <Row type='flex' className='awardsection NesaAwardSection' justify='flex-start' onClick={this.showEagleScoutInformation} align='middle'>
            <Col span={6} className='text-center'>
              <img src="../NESA.png" className='award-img' />
            </Col>
            <Col span={18}>
              <Row type='flex' justify='flex-start' align='middle'>
                <Col span={24}>
                  <span className='award-name'>{Membership_Name.replace(/-/g, " ")}</span>
                </Col>
                <Col span={24}>
                  <span className='m-l-0 award-date'>expires {expireDate ? moment(expireDate).format('MM/DD/YYYY') : "-"}</span>
                </Col>
              </Row>
            </Col>
          </Row>
        }
      }
    }
  }

  showNotification = () => {
    notification['warning']({
      message: 'Social Information',
      duration: 5,
      description: <div> Enter your social media links to connect with another alumni. </div>,
      style: {
        top: 118,
      },
    });
  }

  renderWarning = () => {
    if (this.props.profileinfo) {
      let profile = this.props.profileinfo
      let webcontacts = profile.webContacts
      if (webcontacts.length == 0) {
        return <div className='notify pointer' onClick={() => this.showNotification()}><Icon className='notify-Icon' type="info-circle" /></div>
      }
    }
  }


  renderSearchResults = () => {
    if (this.state.EagleResults.length !== 0) {
        return this.state.EagleResults.map((eagle, i) => {
            return (<div className={this.state.memberSelectedKey == i ? 'eagle-results-active' : 'eagle-results'}
                key={i} onClick={() => {
                  this.setState({
                    memberSelectedKey: i,
                    selectedEagle: eagle
                  })
                }}
            >
                <Row>
                    <Col xs={23}>
                        <Row>
                            <Col xs={24} md={12} lg={12}>
                                <span><b>Name: </b></span><span> {`${eagle.firstName} ${eagle.middleName} ${eagle.lastName}`} </span>
                            </Col>
                            <Col xs={24} md={12} lg={12}>
                                <span><b>Date of Birth: </b></span><span>    {eagle.dateOfBirth ? moment(eagle.dateOfBirth).format('MM/DD/YYYY') : '---'}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} md={12} lg={12}>
                                <span><b>Member ID: </b></span><span>   {eagle.memberId ? eagle.memberId : '---'}</span>
                            </Col>
                            <Col xs={24} md={12} lg={12}>
                                <span><b>Board of Review Date:  </b></span><span>  {eagle.eagleBoardReviewDate ? eagle.eagleBoardReviewDate : '---'}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} md={12} lg={12}>
                                <span><b>Eagle Flag:  </b></span><span>  {eagle.eagleBoardReviewDate ? 'Yes' : 'No'}</span>
                            </Col>
                            <Col xs={24} md={12} lg={12}>
                                <span><b>Awarding Council: </b></span><span>  {eagle.awardingCouncilName ? eagle.awardingCouncilName : '---'} </span>
                            </Col>

                        </Row>
                        <Row>
                            <Col xs={24} md={12} lg={12}>
                                <span><b>Council Unit Number: </b></span><span> {eagle.eagleTroopNumber ? eagle.eagleTroopNumber : "---"}</span>
                            </Col>

                            <Col xs={24} md={12} lg={12}>
                                <span><b>Council City: </b></span><span>  {eagle.eagleCity ? eagle.eagleCity : '---'}</span>
                            </Col>
                        </Row>
                        <Row>

                            <Col xs={24} md={12} lg={12}>
                                <span><b>Council State: </b></span><span>  {eagle.eagleState ? eagle.eagleState : '---'} </span>
                            </Col>
                        </Row>
                        {/* <Row>
                            <Col xs={24} md={12} lg={12}>
                                <span><b>Council State: </b></span><span>  {eagle.eagleState ? eagle.eagleState : '---'} </span>
                            </Col>
                        </Row> */}
                    </Col>
                    {
                        this.state.memberSelectedKey == i ?
                            <Col xs={1}>
                                <i className="fa fa-check-circle margin-right-10 fa-2x SelectedRecord pointer" aria-hidden="true"></i>
                            </Col> : ''
                    }
                </Row>
            </div>
            )
        });
    }
}

  render() {

    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    // const hasAdminRole = this.props.postionsinfo &&
    // Array.isArray(this.props.postionsinfo) &&
    // this.props.postionsinfo.some(function(pos) {
    //   return (
    //     pos.personContext === "AlumniCSTSupport" ||
    //     pos.personContext === "AlumniAdmin" ||
    //     pos.personContext === "AlumniCouncilCommittee"
    //   );
    // });
    
    return (
      <div>
        <LayoutHeader />

        {(this.props.isadmin == true || this.props.isspecialist === true) &&
          <AdminNavigation />
        }

        {(this.props.isadmin == false || this.props.isspecialist === false) &&
          <AlumniNavigation />
        }
        
        <div className='my-profile'>
          <Row type="flex" justify="center">
            <Col>
              <Row>
                {this.props.privacy_updating &&
                  <Col span={24} className='content-center'>
                    <Row type='flex' align='center' justify='center'>
                      <Spin tip="Updating Privacy Information..."></Spin>
                    </Row>
                  </Col>
                }
                {!this.props.privacy_updating &&
                  <Col span={24}>
                    <div className='alumni-profile-banner'>
                      <div className='profile-content'>
                        <div className='bg-banner'>
                          {this.renderWarning()}
                          <Row type="flex" justify="end" align='middle' className='bg-banner-top-row'>
                            <div>
                              {this.props.profileinfo && this.props.profileinfo.webContacts.length != 0 && <span className='connectwithme'> Connect with Me </span>}
                              {this.renderWebContacts()}
                            </div>
                          </Row>
                          <Row type="flex" justify="start" align='middle'>
                            <Col md={5} lg={5} xl={3}>
                              <div className='profile-pic-wrap'>
                                <div className='profilepic-container'>
                                  {this.renderProfileImg()}
                                </div>
                                <Dropdown overlay={<Menu className='PP-menu'>
                                  <Menu.Item>
                                    <Upload
                                      //accept=".jpg,.jpeg,.png"
                                      className="profile-pic-uploader"
                                      name="avatar"
                                      listType="picture-card"
                                      showUploadList={false}
                                      customRequest={dummyRequest}
                                      beforeUpload={beforeUpload}
                                      onChange={this.handleChange}
                                    >
                                      Update Picture
                                  </Upload>
                                  </Menu.Item>
                                  {this.props.profileinfo && this.props.profileinfo.pictures != '' && <Menu.Item>
                                    <Button type="text" onClick={this.RemovePicture.bind(this)}>
                                      Remove Picture
                                    </Button>
                                  </Menu.Item>
                                  }
                                </Menu>} placement="bottomCenter" trigger={['click']}>
                                  <Button type="primary" className="profile-pic-edit" shape="circle" >
                                    <i class="fa fa-camera" aria-hidden="true"></i>
                                  </Button>
                                </Dropdown>
                              </div>
                            </Col>
                            <Col md={17} lg={17} xl={17}>
                              <div>
                                <span className='text' style={{display: 'inline-block'}}>{this.name()}</span>
                                <span className='breadcrums'>{this.checkIsDeceased()}</span>
                              </div>
                              <span className='textdesc'> {this.email()} </span>
                              <span className='textdesc'> {this.phone()} </span>
                              <span className='textdesc'>{this.privacysettings()}</span>
                            </Col>
                            <Col md={2} lg={2} xl={2}>
                              <div className='text-right'> {this.rendereagleflag()} </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>


                    {/* <Row className='awardsandaffiliations' type="flex" justify="center" align="middle">
                      <Col className="gutter-row">
                        <div className='container min-height-550'>
                          <div className='widget-content'>
                            <Row type="flex" justify="space-between">
                              <div className='widget-header-text'>
                                My Scouting Affiliations
                              </div>
                              <div className='widget-header-tool'>
                               //  <label className='pointer' onClick={this.showModal} > Add New </label> 
                              </div>
                            </Row>
                            <Row className='widget-content-section' type="flex" justify="space-between" align="middle">
                              // {this.getNESAreg()} 
                              {this.rendermyscoutings()}
                              {this.renderscouting()}
                            </Row>
                          </div>
                        </div>
                      </Col>

                      <Col className="gutter-row">
                        <div className='container min-height-550'>
                          <div className='widget-content'>
                            <Row type="flex" justify="space-between">
                              <div className='widget-header-text'>
                                My Council Affiliations
                              </div>
                              <div className='widget-header-tool'>
                                //  <label className='pointer' onClick={this.showModal} > Add New </label>
                              </div>
                            </Row>
                            <Row className='widget-content-section' type="flex" justify="space-between" align="middle">
                              {this.rendermyeaglecouncil()}
                              {this.rendermycouncils()}
                              {this.rendercouncils()}
                            </Row>
                          </div>

                        </div>
                      </Col>

                      <Col className="gutter-row">
                      <div className='container min-height-550'>
                        <div className='widget-content'>
                        <Row type="flex" justify="space-between">
                            <div className='widget-header-text'>
                              My Affinity Groups
                            </div>
                            <div className='widget-header-tool'>
                              //  <label className='pointer' onClick={this.showModal} > Add New </label> 
                            </div>
                        </Row>
                        <Row className='widget-content-section' type="flex" justify="space-between" align="middle">
                          {this.renderMyAffinityGroups()}
                          {this.renderAffinityGroups()}
                        </Row>
                        </div>
                      </div>
                    </Col>

                    <Col className="gutter-row">
                        <div className='container min-height-550'>
                          <div className='widget-content'>
                            <Row type="flex" justify="space-between">
                              <div className='widget-header-text'>
                                My National Awards
                          </div>
                              <div className='widget-header-tool'>
                                // <label className='pointer' onClick={this.showModal} > Add New </label> 
                              </div>
                            </Row>
                            <Row className='widget-content-section' type="flex" justify="space-between" align="middle">
                              {this.renderAwards()}
                            </Row>
                            {/* <div className='footer-txt'>
                        <span> <Icon type="question-circle-o" className='margin-right-5' />
                          Looking for an award and it’s not visible?
                        <Tooltip title="972-580-2000">
                            <span className='help-txt'> Contact membercare </span>
                          </Tooltip>
                        </span>
                      // </div> 
                          </div>
                        </div>
                      </Col>

                    <Col className="gutter-row">
                      <div className='container min-height-550'>
                        <div className='widget-content'>
                        <Row type="flex" justify="space-between">
                            <div className='widget-header-text'>
                              My Local Awards
                            </div>
                        </Row>
                        <Row className='widget-content-section' type="flex" justify="space-between" align="middle">
                            {this.renderMyLocalAwardsSection()}
                            {this.renderLocalAwardsSection()}
                        </Row>
                        </div>
                      </div>
                    </Col>
                </Row> */}

                    <MyAwardsComponent 
                      addLocalAwards={this.addLocalAwards} 
                      addscoutings={this.addscoutings}
                      addCouncils={this.addCouncils}
                      addAffinities={this.addAffinities}
                    />
                    <div className='hobbiesAndBusiness margin-10'>
                      <HobbiesAndBusinessComponent eagleInfo={this.props.eagleInfo} />
                      <SocialInfo />
                    </div>
                    {/* <AddPerson /> */}
                    {/* <SocialInfo /> */}
                    {/* Alumni Information */}
                    <AlumniInfo />
                    <div className='container profile-contact-info '>
                      <AlumniPrivacyOptions />
                    </div>
                    {/* Contact Information */}
                    <ContactInfo />

                    {/* Address Information */}
                    <AddressInfo />
                    <div className=''> <AllNesaMembership /> </div>
                    {/* Additional Information */}
                    {/* <AdditionalInfo />  */}



                  </Col>
                }
              </Row>
            </Col>
            <Col xs={22} sm={22} md={22} lg={6} xl={6}>
            </Col>
          </Row>
        </div>


        <Modal
            centered
            className='NesaMembershipModal'
            visible={this.state.InfoVisible}
            closable={false}
            title="Welcome to National Eagle Scout Association"
            footer={[
              <div className="NesaMembershipModalFooter" >
                  <div className="CancelNesaMembershipAction">
                    <Button key="back" className="CancelNesaMembershipModal" onClick={this.Closemodal}>
                      Cancel
                    </Button>  
                  </div>
                {this.state.hasCurrentNESAmembership &&
                  <div className="NESAMembershipActions">
                    <Button key="submit" type="primary" className="GoToPurchaseNesaMembership" onClick={() => {
                      this.setState({
                        // InfoVisible: false
                        // showNESARegistrationsModal: true
                      })
                      let values = {
                        // scout_first_name: 'Gary',
                        // scout_last_name:  'Weibel',
                        // scout_dob:  '08/24/2004',
                        scout_first_name: this.props.profileinfo.profile.firstName,
                        scout_last_name:  this.props.profileinfo.profile.lastName,
                        scout_dob:  this.props.profileinfo.profile.dateOfBirth,
                      }
                      // this.props.actions.getmemberid(personGUID, true, values, true)
                      this.props.actions.searchEagle(values, personGUID, true)

                    }}
                      loading={this.props.searching}
                    >
                      Current Member
                    </Button>
                  </div>
                }
                  <div className="NESAMembershipActions">
                     {/* {this.renderViewNesaStatusButton()} */}
                                                
                      <Button key="submit" type="primary" className="GoToPurchaseNesaMembership" onClick={this.gotoPurchaseMembership}>
                        Purchase Membership
                      </Button>
                  </div>                  
              </div>
            ]}
        >
          Did you know NESA members empower Scouting's mission and protect the Eagle Scout legacy for future generations?
          Membership gives your Eagle pride a purpose. If you are not a member, please join today.

          {!this.state.hasCurrentNESAmembership && 
            <div className='note-text'>
            NOTE: You do not have any current NESA membership
            </div>
            }
        </Modal>

        <Modal
                    className='multiple-r-modal'
                    title={false}
                    footer={false}
                    visible={this.state.showResultModal}
                    centered
                    onCancel={() => this.closeResult()}
                >
                    <div>
                        <span className='modal-header'>Multiple Records Found</span>
                        <span className='modal-desc'>Multiple records were found, please select one.</span>
                    </div>

                    {this.renderSearchResults()}

                    <Row type='flex' style={{ justifyContent: 'end', alignItems: 'center' }}>
                        <Col className='xs-center sm-center' xs={24} sm={24} md={24} lg={13} xl={13} >
                            <div className='step-container margin-top-20' >
                                <Button type="primary" className='back-btn' style={{ fontSize: '13px', width: '100%' }} onClick={() => this.NoResultsMatchMyProfileAlert()}>No Search Results Match My Profile</Button>
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5} offset={2}>
                            <div className='step-container margin-top-20' >
                                <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                    // this.props.actions.getProfileInfo(this.state.selectedRecord.personGuid)
                                    // this.props.actions.getAlumniEagleInfo(this.state.selectedRecord.personGuid)
                                    this.props.actions.getNESARegistrations(this.state.selectedEagle.personGuid, true);
                                    if (!this.state.selectedEagle.eagleBoardReviewDate || !this.state.selectedEagle.eagleCertificationDate ) {
                                      this.setState({
                                        EagleincompleteInfoVisible: true,
                                        showNESARegistrationsModal: false,
                                        // hasCurrentNESAmembership: false,
                                        memberSelectedKey: 0,
                                      })
                                    } else {   
                                      this.setState({
                                        showNESARegistrationsModal: true,
                                        memberSelectedKey: 0,
                                      })
                                    }
                                    this.closeResult();
                                }} htmlType='submit'>SELECT</Button>
                            </div>
                        </Col>
                    </Row>
                </Modal>

        {/* <Modal
          centered
          className='NESARegistrationsModal'
          title=""
          visible={this.state.showNESARegistrationsModal}
          onCancel={() => {
            this.setState({showNESARegistrationsModal :false})
            this.showResults()
            this.props.actions.getNESARegistrations(personGUID)
        }}
          footer={false}
        >
          <Row gutter={48} className="eagle-info-container">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <fieldset style={{ padding: "20px" }}>
                <legend>NESA Memberships:</legend>
                <NESARegistrations personGUID={this.state.selectedEagle ? this.state.selectedEagle.personGuid : this.props.personGUID}
                />
                {!this.state.hasCurrentNESAmembership  && 
            <div className='note-text'>
            NOTE: You do not have any current NESA membership for this Member ID
            </div>
            }
              </fieldset>
            </Col>
          </Row>

        </Modal>  */}

          {/* {
          this.props.eagleInfo ? 

          <Modal
          centered
          className='EagleScoutInformationModal'
          title="Eagle Information"
          visible={this.state.EagleScoutInfoVisible}
          closable={false}
          footer={[
              <div className="EagleInfoFooterActions">
                  {this.renderRenewMembershipButton()}
                  <Button key="back" className="CloseEagleInformation" onClick={this.closeEagleScoutInfoModal}>
                      OK
                  </Button>
              </div>
          ]}
          >
            <Row gutter={48} className="eagle-info-container">
              <Row className="eaglescout-info-panel">
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Member ID: </label>
                      <label className='membership-field-value'>{this.props.eagleInfo.memberId ? this.props.eagleInfo.memberId : '- -'}</label>
                  </Col>
                  <Col span={14}>
                      <label className='membership-field-label'> First Name:  </label>
                      <label className='membership-field-value'>{this.props.eagleInfo.firstName ? this.props.eagleInfo.firstName : '- -'}</label>
                  </Col>
              </Row>
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Middle Name:  </label>
                      <label className='membership-field-value'>{this.props.eagleInfo.middleName ? this.props.eagleInfo.middleName : '- -'}</label>
                  </Col>
                  <Col span={14}>
                      <label className='membership-field-label'>  Last Name:  </label>
                      <label className='membership-field-value'>{this.props.eagleInfo.lastName ? this.props.eagleInfo.lastName : '- -'}</label>
                  </Col>
              </Row>
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Date of Birth:  </label>
                      <label className='membership-field-value'>{
                        this.props.eagleInfo.dateOfBirth ? moment(this.props.eagleInfo.dateOfBirth).format('MM/DD/YYYY') : '---'
                      }</label>
                  </Col>
                  <label className='membership-field-label'>  Board Review Date:  </label>
                  <label className='membership-field-value'>
                    {
                      this.props.eagleInfo.eagleBoardReviewDate ? moment(this.props.eagleInfo.eagleBoardReviewDate).format('MM/DD/YYYY') : '---'
                    }
                  </label>
              </Row>

              <Row type='flex' align='middle'>
                  <Col span={10}>
                    <label className='membership-field-label'>  Eagle Unit Number:  </label>
                    <label className='membership-field-value'>
                      {this.props.eagleInfo.eagleUnitNumber ? this.props.eagleInfo.eagleUnitNumber : '---'}
                    </label>
                  </Col>
                  <Col span={14}>
                  <label className='membership-field-label'>  Eagle Scout City:  </label>
                  <label className='membership-field-value'>
                    {this.props.eagleInfo.eagleUnitCity ? this.props.eagleInfo.eagleUnitCity : '---'}
                  </label>
                  </Col>
              </Row>
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Eagle Scout State:  </label>
                      <label className='membership-field-value'>{this.props.eagleInfo.eagleUnitState ? this.props.eagleInfo.eagleUnitState : '---'}</label>
                  </Col>
                  <Col span={14}>
                      
                  </Col>
              </Row>
              </Row>
            </Row>

            <div className="MembershipInfoHeader">
                NESA MEMBERSHIP INFORMATION
            </div>
            <div className="MembershipInfoHeaderPath"></div>

            {this.renderEagleMembershipInfo()}

          </Modal> : ""
      } */}

      <Modal
          centered
          className='EagleIncompleteInfoModal'
          closable={false}
          visible={this.state.EagleincompleteInfoVisible}
          footer={
            <Button key="back" className="CloseEagleIncompleteInfo"  onClick={this.closeEagleIncompleteInfoModal}>
              OK
            </Button>
          }
      >
          <div className="IncompleteInfoWarningImage">
              <img src={warningAlert} width="47px" height="47px"></img>
          </div>  
          <div className="NESAMembershipInfoHeader">
              Looks like your Eagle Scout information needs to be updated.
          </div>
          <div className="NESAMembershipInfoContent">
            We found you but your Eagle Scout Information is incomplete. Please contact the council from which you
            earned your Eagle rank to update or add missing information. Required field include: Birthday, Member ID, and/  or
            Board Of Review Date.
          </div>
          <div className="NESAMembershipWaitInfo">
            Please allow 24 - 48 hours for the information to update in our system and try again.
          </div>

          <div className="IncompleteInfoCouncilNumber">
          <span className="EagleCouncilNumberInfo">Eagle Scout Council Number: 
              <span className="text-style-1">
                {this.renderEagleCouncilNumber()}
              </span> 
            </span>
          </div>

          <div className="IncompleteInfoMemberID">
            <span className="EagleScoutMemberID">Eagle Scout Member ID: 
              <span className="text-style-1">{this.state.selectedEagle && this.state.selectedEagle.memberId ?  this.state.selectedEagle.memberId : ''}</span> 
            </span>
          </div>

          {/*Listing Missing Information */}
          <div className="MissingEagleInformation">
              <span className="MissingEaglePropertyHeader">Missing Information: </span>
              <span className="MissingEaglePropertyValue"> { this.renderMisssingEagleInfo() } </span> 
          </div>
      </Modal>

      <Modal
                    className='No-records-match-myMrofile-model'
                    title={false}
                    footer={false}
                    visible={this.state.NoResultsMatchProfile}
                    centered
                    onCancel={() => this.closeNorecordsMatchProfile()}
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className='No-Results-Match-Pro'>
                            No Results Match Profile
                        </div>

                        <div className='margin-bottom-20'> Whoops! It appears no current Eagle Scout record matches your Eagle Scout information. Please confirm the Eagle Scout MemberID and try again.</div>
                        <div>Alternatively, please contact the Scout's Eagle Scout council for further assistance.</div>

                        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                                <div className='step-container margin-top-20' >
                                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                        this.closeNorecordsMatchProfile();
                                    }} htmlType='submit'>CLOSE </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>

      </div>
    );
  }
}



function mapStateToProps(state) {
  return {
    profileinfo: state.profilereducer.profileinfo,
    profileloading: state.profilereducer.loading,
    isadmin: state.isadminreducer.isadmin,
    eagleInfo: state.eagleinforeducer.eagleinfo,
    ranks_loading: state.myranksreducer.loading,
    ranks: state.myranksreducer.ranks,
    allranks_loading: state.allranksreducer.loading,
    allranks: state.allranksreducer.ranks,
    pic_updating: state.profilepicturereducer.loading,
    pic_updated: state.profilepicturereducer.status,
    privacy_updating: state.privacysettingsreducer.loading,
    awardsloading: state.awardsreducer.loading,
    awards: state.awardsreducer.awards,
    affinities_loading: state.affinitiesreducer.loading,
    affinities: state.affinitiesreducer.affinities,
    localAwards_Loading: state.localAwardsReducer.loading,
    localAwards: state.localAwardsReducer.localAwards,
    scoutings_loading: state.scoutingsreducer.loading,
    scoutings: state.scoutingsreducer.scoutings,
    scoutings_deleting: state.scoutingsdeletereducer.loading,
    scoutings_adding: state.scoutingsaddreducer.loading,
    councils: state.councilsreducer.councils,
    councils_adding: state.councilsaddreducer.loading,
    councils_deleting: state.councildeletereducer.loading,
    nesa_loading: state.nesaregistrationreducer.loading,
    nesa_reg: state.nesaregistrationreducer.reg,
    nesa_levels_loading: state.nesalevelsreducer.loading,
    nesa_levels: state.nesalevelsreducer.levels,
    isspecialist: state.isadminreducer.isspecialist,
    searching: state.eagleSearchReducer.searching,
    searchedEagle: state.eagleSearchReducer.eagle,
    postionsinfo: state.GetPositionsReducer.postionsinfo
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(MyProfile);


// WEBPACK FOOTER //
// ./src/components/MyProfile/myprofile.js